module.exports = __webpack_public_path__ + "img/260.register_load.33a709aa.svg";